import { apiClient } from "@/lib/api";
import type { PaginationParams, WalletTransactionsResponse } from "@/types";

export interface WalletTransactionFilters extends PaginationParams {
  start_date?: string;
  end_date?: string;
  activity_id?: string;
  transaction_type?: "CREDIT" | "DEBIT";
  min_amount?: number;
  max_amount?: number;
  description_search?: string;
}

/** Wallet aggregate stats — amounts are integer cents. */
export interface WalletStats {
  total_credits: number;
  total_debits: number;
  transactions_count: number;
  credit_transactions_count: number;
  debit_transactions_count: number;
}

export const walletService = {
  getTransactions: async (
    userId: string,
    params?: WalletTransactionFilters,
  ): Promise<WalletTransactionsResponse> => {
    const response = await apiClient.get<WalletTransactionsResponse>(
      `/users/${userId}/wallet/transactions`,
      { params },
    );
    return response.data;
  },

  getStats: async (
    userId: string,
    params?: {
      start_date?: string;
      end_date?: string;
      activity_id?: string;
    },
  ): Promise<WalletStats> => {
    const response = await apiClient.get<WalletStats>(
      `/users/${userId}/wallet/stats`,
      { params },
    );
    return response.data;
  },
};
